<template>
    <div class="app">
        <TopNav></TopNav>
        <div class="center">
            <div class="news1-hd">
            </div>
            <div class="news1-hd-top">
                <div class="content_row">
                    <h2>图说调查报告：2021年农贸市场发展情况！</h2>

                    <img src="../../assets/news2-1.png" alt="新闻图片1">
                    <img src="../../assets/news2-2.png" alt="新闻图片2">
                    <img src="../../assets/news2-3.png" alt="新闻图片3">
                    <img src="../../assets/news2-4.png" alt="新闻图片4">
                    <img src="../../assets/news2-5.png" alt="新闻图片5">
                </div>
            </div>
        </div>
        <BottomNav></BottomNav>
    </div>
</template>

<script>
import TopNav from '../../components/TopNav.vue'
import BottomNav from '../../components/BottomNav.vue'
export default {
    components: { TopNav, BottomNav },
    data() {
        return {

        }
    },
    created() { },
    mounted() {

    },
    methods: {},
}
</script>

<style lang="less" scoped>
.app {
    width: 100vw;
    height: 100vh;
    background-size: cover;
    z-index: -1;
    overflow-x: hidden;
}

.center {
    width: 100%;
    min-height: calc(100vh - .8333rem - 5.9063rem);
    margin-top: .8333rem;
    overflow: hidden;
}

.content_row {
    width: 100%;
    height: 100%;
    padding: 0 7rem;
    box-sizing: border-box;
}

.title_content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.title_content .title {
    display: flex;
    align-items: center;
}

.title_content img {
    width: 1.1458rem;
    height: .2292rem;
}

.title_content h1 {
    font-size: .3958rem;
}

.title_content p {
    height: .3021rem;
    font-size: .2188rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232A24;
    line-height: .3021rem;
    margin-top: .2917rem;
}

.news1-hd {
    width: 100%;
    height: 5.2083rem;
    background: url(../../assets/news-bj.png) no-repeat center;
    background-size: 100% 5.2083rem;
    margin-top: .8333rem;
    z-index: -1;
    margin-bottom: .3125rem;
}

.news1-hd-top {
    height: 54.25rem;
    text-align: center;
}

.news1-hd-top h2 {
    width: 100%;
    height: .5208rem;
    line-height: .5208rem;
    text-align: center;
    color: #000;
    font-size: .3333rem;
    margin-bottom: .5208rem;
}

.news1-hd-top .news1-hd-box1 {
    text-align: center;
    font-size: .2083rem;
    line-height: .2604rem;
    color: rgb(194, 79, 74);
    margin-bottom: .3125rem;
}

.news1-hd-top img {
    width: 6.6667rem;
    height: 10rem;
    margin-bottom: .5rem;
}

.news1-hd-top p {
    text-indent: 2em;
    margin-bottom: .25rem;
    font-size: .2283rem;
    line-height: .3604rem;
    text-align: left;
}
</style>